import { Typography, Stack } from "@mui/material";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { PackageCard } from "./PackageCard";
import { useGetAirtimeById } from "./utility";
import { useUtilityContent } from "./UtilityContent";
import { FormInput } from "../../atoms";

export const AirtimeFormSection = () => {
  const { airtimeId } = useParams();
  const {
    form: {
      register,
      formState: { errors },
      setValue,
      watch,
    },
    setBill,
  } = useUtilityContent();
  const { mutate: getAirtime, data } = useGetAirtimeById();
  useEffect(() => {
    getAirtime(airtimeId, {
      onSuccess: (result) => {
        setValue("amount", result.amount.toString());
        setBill({ categoryName: "Aritime", name: result.name, logoUrl: result.logoUrl });
      },
    });
  }, []);

  return (
    <div>
      <PackageCard />
      <div style={{ marginTop: "40px" }}>
        <Typography sx={{ fontSize: "20px", fontWeight: 700, lineHeight: "24px" }}>Airtime</Typography>
        <Stack spacing={2} direction="row" sx={{ marginTop: "40px" }}>
          <FormInput required label="Phone Number" {...register("customerId")} helperText={errors.customerId?.message} />
          <FormInput value={watch("amount")} isNumber required startAdornment={data?.currencySymbol} label="Amount" disabled={!!data?.amount} {...register("amount")} helperText={errors.amount?.message} />
        </Stack>
      </div>
    </div>
  );
};
